<label class="secondary">
	{{ T.LABEL_RUNS | translate }}
</label>
<div class="runRow">
	<sim-chevron-overflow>
		@for (run of runs(); track run.runId) {
			<div class="run" [class.last]="$last">
				<div class="vector">
					<sim-session-run-vector [index]="$index" size="small" />
				</div>
				<span class="start">{{ run.startTime | date: timeFormat() :'': translate.currentLang }}</span>
				<span class="duration"> {{ run.durationMinutes }}' </span>
				<span class="intermission">
					@if (run.intermissionDurationMinutes) {
						+
						<mat-icon fontIcon="fa-coffee" fontSet="fal" inline />{{ run.intermissionDurationMinutes }}'
					}
				</span>
			</div>
			@if ($last) {
				<div class="end">
					<mat-icon fontIcon="fa-stop-circle" fontSet="fad" inline />
					<span> {{ run.startTime.getTime() + run.durationMinutes * 60000 | date: timeFormat(): translate.currentLang }} </span>
				</div>
			}
		}
	</sim-chevron-overflow>
</div>
